export default __webpack_public_path__ + "locales/sl/FilesSettings.json?hash=b91142064f8a254f34aecadc866b9432";